@if (authenticationService.isExternalUser) {
  <div
    class="home-page welcome-page"
    >
    @if (isTenantMultiple) {
      <div>
        @if (!isLoading) {
          <div class="progress-spinner-container flex justify-center items-center">
            @if (!isLoading) {
              <p-progressSpinner></p-progressSpinner>
            }
          </div>
        }
        @if (isLoading) {
          <div>
            <fieldset class="my-nexus-default-fieldset" id="welcome-view">
              <div class="fieldset-padding">
                <h3 class="colored-text">
                  Welcome <span class="colored-text">{{ userName }}</span>
                </h3>
                <p>
                  Welcome to the Carelon Medical Benefits Management Portal! Please select the health plan you wish to
                  access.
                </p>
              </div>
              <div>
                <fieldset class="my-nexus-default-fieldset">
                  <legend class="my-nexus-default-legend">Health Plans</legend>
                  @for (tenant of tenants; track tenant) {
                    <div>
                      <a href="javascript:" data-test-id="health-plan-link" (click)="routeToPlan(tenant)">{{ tenant.name }}</a>
                    </div>
                  }
                </fieldset>
              </div>
            </fieldset>
          </div>
        }
      </div>
    }
    @if (!isTenantMultiple) {
      <div>
        @if (!isContentLoaded) {
          <p-progressSpinner></p-progressSpinner>
        }
        @if (isContentLoaded) {
          <div>
            <fieldset class="my-nexus-default-fieldset">
              <legend class="my-nexus-default-legend">Health Plans</legend>
              @for (tenant of tenants; track tenant) {
                <div>
                  <a href="javascript:" data-test-id="health-plan-link" (click)="routeToPlan(tenant)">{{ tenant.name }}</a>
                </div>
              }
            </fieldset>
          </div>
        }
        @if (isContentLoaded) {
          <app-home-page-block
            [contentPage]="contentPage"
            [tenantName]="tenantName"
            [userName]="userName"
          ></app-home-page-block>
        }
      </div>
    }
  </div>
}
